const StatsTabsNav = ({ activeTab, setActiveTab }) => (
  <div className="flex border-b border-gray-200 mb-4">
    <TabButton
      active={activeTab === "goals"}
      onClick={() => setActiveTab("goals")}
    >
      Goles
    </TabButton>
    <TabButton
      active={activeTab === "assists"}
      onClick={() => setActiveTab("assists")}
    >
      Asistencias
    </TabButton>
    <TabButton
      active={activeTab === "yellow"}
      onClick={() => setActiveTab("yellow")}
    >
      Amarillas
    </TabButton>
    <TabButton active={activeTab === "red"} onClick={() => setActiveTab("red")}>
      Rojas
    </TabButton>
  </div>
);

const TabButton = ({ active, onClick, children }) => (
  <button
    className={`py-2 px-4 font-medium ${
      active ? "text-blue-600 border-b-2 border-blue-600" : "text-gray-500"
    }`}
    onClick={onClick}
  >
    {children}
  </button>
);

export default StatsTabsNav;
